module.exports = __webpack_public_path__ + "img/icon-lab-manager-store.f8ba7851.svg";